<template>
  <div>
    <vs-popup :title="$t('CreateNewTransportFleet')" :active.sync="showModal">
      <form>
        <div class="vx-col w-full mb-2">
          <vs-input
            class="inputx my-1"
            v-model="model.name"
            name="name"
            :label="$t('Name')"
            v-validate="'required'"
          />
          <span class="text-danger text-sm my-1" v-show="errors.has('name')">{{
            errors.first("name")
          }}</span>
        </div>
        <vs-button
          type="filled"
          class="float-right my-2"
          @click.prevent="submitForm"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    name: {
      required: "لطفا نام را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "shipping-TransportFleets-createPopup",
  components: {},
  props: {
    show: { default: false },
  },
  data() {
    return {
      model: {},
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createTransportFleet: "shipping/createTransportFleet",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createTransportFleet(this.model)
            .then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model.name = "";
            })
            .catch((e) => {
              this.$swal({
                position: "center-center",
                type: "warning",
                text: e.Message,
                showConfirmButton: false,
                timer: 2000,
              });
            });
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.model.name = "";
      }
    },
  },
};
</script>
